import { render, staticRenderFns } from "./HintProduction.vue?vue&type=template&id=036ac1ea&scoped=true"
import script from "./HintProduction.vue?vue&type=script&lang=js"
export * from "./HintProduction.vue?vue&type=script&lang=js"
import style0 from "./HintProduction.vue?vue&type=style&index=0&id=036ac1ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ac1ea",
  null
  
)

export default component.exports